export const validatePAN = (panNumber) => {
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (!panNumber || !panRegex.test(panNumber)) {
        return false;
    }
    return true;
};

// The 4th character of a PAN is its holder-type code; 'P' is an individual, everything else is a
// company, HUF, trust or firm.
export const isIndividualPan = (panNumber?: string | null): boolean => {
    const value = panNumber?.trim().toUpperCase();
    return !!value && validatePAN(value) && value[3] === 'P';
};
